import httpService from '@/services/httpService'
import { convertAdvancedOptionsToURLParams } from '@/store/modules/rank-zone/Helper'
// eslint-disable-next-line no-unused-vars
import Progress from '../../../features/reports/rank-zone/progress/Progress'

export const types = {
  ADD_PROGRESS_DATA: 'rank-zone/ADD_PROGRESS_DATA',
  SORT_ANNOTATIONS: 'rank-zone/SORT_ANNOTATIONS'
}
const emptyData = {
  annotations: [],
  progress: [],
  snapshot_dates: []
}
const state = { ...emptyData }

const mutations = {
  [types.ADD_PROGRESS_DATA]: function (state, { progress, snapshot_dates, annotations = [] }) {
    state.progress = progress || []
    state.snapshot_dates = snapshot_dates || []
    state.annotations = annotations.map(i => {
      i.isEdit = false
      i.prevNote = i.note
      i.prevDate = i.date
      i.prevType = i.type
      i.disableButtons = false
      i.errorFields = []
      return i
    })
  },
  [types.SORT_ANNOTATIONS]: function (state) {
    state.annotations = state.annotations.sort((a, b) => new Date(b.date) - new Date(a.date))
  }
}

const actions = {
  getProgressData: async function ({ commit, dispatch, rootState }, { clientId, filters }) {
    const msv = JSON.parse(localStorage.getItem('msv')) || {}
    filters.msv = msv[clientId] || 1
    let params = null
    if (filters && filters.advancedFilters) {
      params = convertAdvancedOptionsToURLParams(filters)
    } else {
      params = filters
    }
    const response = await httpService.get(`/reports/rankzone-report/progress/${clientId}`, { params: params },
      { encode: false, cancel: true, cancelToken: '/reports/rankzone-report/progress/' })
    if (!response || !response.data) {
      return
    }
    commit(types.ADD_PROGRESS_DATA, response.data)
  },
  sortAnnotations: async function ({ commit }) {
    commit(types.SORT_ANNOTATIONS)
  },
  resetProgressData: function ({ commit }) {
    commit(types.ADD_PROGRESS_DATA, emptyData)
  }
}

/**
 * Store keep data for {@link Progress} component
 */
export default {
  namespaced: true,
  state,
  actions,
  mutations
}
